<template>
  <div>
    <v-dialog
      v-model="showModal"
      persistent
      fullscreen
    >
      <div class="content-section">
        <h1 class="header-style">
          Timesheet Details
        </h1>
        <br>
        <v-form
          ref="form"
          v-model="isFormValid"
          class="mt-6"
          lazy-validation
        >
          <div class="mb-4">
            <v-row>
              <v-col
                cols="12"
                class="py-0"
              >
                <v-select
                  v-model="selectedProject"
                  light
                  color="#37474F"
                  flat
                  dense
                  :items="projectsList"
                  item-text="name"
                  item-value="id"
                  label="Project*"
                  outlined
                  :rules="[(v) => !!v || 'This field is required']"
                  background-color="#FFF"
                  class="small-select"
                  @input="getFilterAppUsersList(entry.selectedProject)"
                />
                <!-- <p
                  v-if="timesheetDetails.checkin_record !== null"
                  style="margin-top: -25px;
                  font-size: 12px;
                  color: grey;"
                >
                  Project can’t be changed for check-in timesheets.
                </p> -->
              </v-col>
              <v-col
                v-if="canEditAll"
                cols="12"
                class="py-0"
              >
                <v-select
                  v-model="selectedUser"
                  light
                  color="#37474F"
                  flat
                  dense
                  :items="filterAppUserList"
                  item-text="first_name"
                  item-value="app_user_organization_id"
                  label="User*"
                  outlined
                  :rules="[(v) => !!v || 'This field is required']"
                  background-color="#FFF"
                  class="small-select"
                  :disabled="timesheetDetails.checkin_record !== null"
                />
                <p
                  v-if="timesheetDetails.checkin_record !== null"
                  style="margin-top: -25px; font-size: 12px; color: grey"
                >
                  User can’t be changed for check-in timesheets.
                </p>
              </v-col>
              <v-col
                cols="6"
                class="py-0"
              >
                <v-dialog
                  :ref="'fromDialog'"
                  v-model="timesheetStartDateCalender"
                  width="290px"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="timesheetStartDate"
                      label="Start Date"
                      light
                      dense
                      outlined
                      background-color="#FFF"
                      :rules="[(v) => !!v || 'This field is required']"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-if="timesheetStartDateCalender"
                    v-model="timesheetStartDate"
                    full-width
                    color="#37474F"
                    light
                    :max="maxStartDate"
                    @change="timesheetStartDateCalender = false"
                  >
                    <v-spacer />
                    <v-btn
                      text
                      color="#37474F"
                      @click="timesheetStartDateCalender = false"
                    >
                      Cancel
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col
                cols="6"
                class="py-0"
              >
                <v-dialog
                  :ref="'fromDialog'"
                  v-model="timesheetEndDateCalender"
                  width="290px"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="timesheetEndDate"
                      label="End Date"
                      light
                      dense
                      outlined
                      background-color="#FFF"
                      :rules="[(v) => !!v || 'This field is required']"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-if="timesheetEndDateCalender"
                    v-model="timesheetEndDate"
                    full-width
                    color="#37474F"
                    light
                    :max="maxStartDate"
                    @change="timesheetEndDateCalender = false"
                  >
                    <v-spacer />
                    <v-btn
                      text
                      color="#37474F"
                      @click="timesheetEndDateCalender = false"
                    >
                      Cancel
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col
                cols="6"
                class="py-0"
              >
                <v-dialog
                  ref="dialog"
                  v-model="startTimeModal"
                  persistent
                  width="290px"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="startTime"
                      label="Start Time*"
                      light
                      dense
                      filled
                      outlined
                      color="#000000"
                      background-color="#FFF"
                      :suffix="userTimeZone"
                      :rules="[(v) => !!v || 'Check-out Time is required']"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-time-picker
                    v-if="startTimeModal"
                    v-model="timeStart"
                    color="#37474F"
                    light
                    full-width
                    @change="calculateDuration()"
                  >
                    <v-spacer />
                    <v-btn
                      text
                      color="primary"
                      @click="startTimeModal = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="
                        () => {
                          startTime = timeStart;
                          startTimeModal = false;
                        }
                      "
                    >
                      OK
                    </v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-col>
              <v-col
                cols="6"
                class="py-0"
              >
                <v-dialog
                  ref="dialog"
                  v-model="endTimeModal"
                  persistent
                  width="290px"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="endTime"
                      label="End Time*"
                      light
                      dense
                      filled
                      outlined
                      color="#000000"
                      background-color="#FFF"
                      :suffix="userTimeZone"
                      :rules="[(v) => !!v || 'Check-out Time is required']"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-time-picker
                    v-if="endTimeModal"
                    v-model="timeEnd"
                    color="#37474F"
                    light
                    full-width
                    @change="calculateDuration()"
                  >
                    <v-spacer />
                    <v-btn
                      text
                      color="primary"
                      @click="endTimeModal = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="
                        () => {
                          endTime = timeEnd;
                          endTimeModal = false;
                        }
                      "
                    >
                      OK
                    </v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-col>
              <v-col
                v-if="isBreakEnabled"
                cols="12"
                class="py-0"
              >
                <v-text-field
                  v-model="breakDuration"
                  label="Break Hours"
                  placeholder="HH:mm"
                  maxlength="5"
                  dense
                  light
                  color="#000000"
                  background-color="#FFF"
                  outlined
                  :rules="[validateBreakDuration]"
                  @input="formatBreakDuration"
                />
              </v-col>
              <v-col
                cols="12"
                class="py-0"
              >
                <v-textarea
                  v-model="notes"
                  outlined
                  light
                  class="field-text-style"
                  :counter="100"
                  counter-value-color="red"
                  filled
                  color="#000000"
                  background-color="#FFF"
                  label="Notes"
                  dense
                  rows="2"
                />
              </v-col>

              <v-col
                v-if="verifiedHours || paymentHours || actualWorkedHours"
                cols="12"
                class="py-0"
              >
                <div class="calculated-hours-panel pa-4 mb-4 rounded-lg">
                  <h4 class="text-subtitle-2 mb-3">
                    Calculated Hours
                  </h4>
                  <v-row dense>
                    <v-col
                      v-if="verifiedHours"
                      :cols="dynamicCols"
                    >
                      <v-text-field
                        v-model="verifiedHours"
                        label="Verified Hours"
                        dense
                        outlined
                        readonly
                        filled
                        background-color="#FFF"
                        hide-details
                        light
                        class="field-text-style"
                        disabled
                      />
                    </v-col>
                    <v-col
                      v-if="paymentHours"
                      :cols="dynamicCols"
                    >
                      <v-text-field
                        v-model="paymentHours"
                        label="Payment Hours"
                        dense
                        outlined
                        readonly
                        filled
                        background-color="#FFF"
                        hide-details
                        light
                        class="field-text-style"
                        disabled
                      />
                    </v-col>
                    <v-col
                      v-if="actualWorkedHours"
                      :cols="dynamicCols"
                    >
                      <v-text-field
                        v-model="actualWorkedHours"
                        label="Actual Worked Hours"
                        dense
                        outlined
                        readonly
                        filled
                        background-color="#FFF"
                        hide-details
                        light
                        class="field-text-style"
                        disabled
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-col>

              <v-col
                cols="12"
                class="py-0"
              >
                <v-text-field
                  :value="`${workerHours}:${workerMins}`"
                  label="Worked Hours*"
                  dense
                  outlined
                  light
                  disabled
                  background-color="#FFF"
                  class="purple-input"
                />
              </v-col>
              <v-col
                cols="12"
                class="py-0"
              >
                <v-select
                  v-model="type"
                  light
                  color="#37474F"
                  flat
                  dense
                  :items="payItems"
                  item-text="name"
                  item-value="id"
                  label="Pay Item"
                  outlined
                  background-color="#FFF"
                  class="small-select"
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
            </v-row>
          </div>
        </v-form>
        <span
          v-if="
            timesheetDetails.status !== 'approved' &&
              timesheetDetails.status !== 'declined' &&
              timesheetDetails.status !== 'time-verified' && selectedOrganization.active
          "
        >
          <div
            v-if="
              timesheetDetails.status !== 'declined' &&
                timesheetDetails.status !== 'time-verified'
            "
          >
            <v-btn
              v-if="editOwnPermission || editAllPermission"
              class="btn-style"
              color="#64CA7F"
              elevation="0"
              @click="updateTimesheets"
            >
              Update
            </v-btn>
          </div>
          <v-btn
            v-if="deleteOwnPermission || deleteAllPermission"
            class="btn-style grey-button"
            color="#E52020"
            elevation="0"
            @click="showDeleteDialog = true"
          >
            <v-icon> mdi-trash-can-outline </v-icon>
          </v-btn>
        </span>
        <v-btn
          fab
          color="#FFF"
          small
          rounded
          elevation="0"
          class="close-button"
          @click="showModal = false"
        >
          <v-icon color="#37474f">
            mdi mdi-close
          </v-icon>
        </v-btn>
      </div>
      <alert-dialog
        v-if="showDeleteDialog"
        :title="'Delete Timesheet'"
        :message="'Are you sure you want to delete this timesheet ?'"
        @closed="showDeleteDialog = false"
        @confirmed="confirmDelete"
      />
      <centre-spinner :loading="loading" />
    </v-dialog>
  </div>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';
import AlertDialog from '../../../../components/AlertDialog.vue';
import moment from 'moment-timezone';

export default {
  name: 'TimesheetEdit',
  components: {
    'centre-spinner': spinner,
    'alert-dialog': AlertDialog,
  },
  props: {
    timesheetId: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      showModal: true,
      isFormValid: false,
      loading: false,
      maxStartDate: moment().format('YYYY-MM-DD'),
      selectedProject: null,
      selectedUser: null,
      timesheetStartDateCalender: false,
      timesheetEndDateCalender: false,
      timesheetStartDate: '',
      timesheetEndDate: '',
      notes: '',
      startTime: '',
      endTime: '',
      timeStart: '',
      startTimeModal: false,
      timeEnd: '',
      endTimeModal: false,
      workerHours: '',
      workerMins: '',
      type: '',
      showDeleteDialog: false,
      canEditAll: false,
      deleteOwnPermission: false,
      deleteAllPermission: false,
      editOwnPermission: false,
      editAllPermission: false,
      verifiedHours: null,
      paymentHours: null,
      actualWorkedHours: null,
      breakDuration: '00:00',
    };
  },
  computed: {
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    filterAppUserList () {
      return this.$store.getters['appusers/getFilterAppUsersList'];
    },
    projectsList () {
      return this.$store.getters['projects/getOrganizationProjects'];
    },
    payItems () {
      return this.$store.getters['timesheets/getPayItems'];
    },
    orgSettings () {
      return this.$store.getters['organization/getOrganizationSettings'];
    },
    isBreakDeductionEnabled () {
      return (
        this.orgSettings &&
        this.orgSettings.break &&
        this.orgSettings.break.break_deduction === true
      );
    },

    isBreakEnabled () {
      return (
        this.orgSettings &&
        this.orgSettings.break &&
        this.orgSettings.break.enabled === true
      );
    },

    timesheetDetails () {
      return this.$store.getters['timesheets/getTimesheetDetails'];
    },
    userTimeZone () {
      var Zone = moment.tz.guess();
      var timezone = moment.tz(Zone).zoneAbbr();
      return timezone;
    },
    visibleFieldsCount () {
      let count = 0;
      if (this.verifiedHours) count++;
      if (this.paymentHours) count++;
      if (this.actualWorkedHours) count++;
      return count || 1;
    },
    dynamicCols () {
      return Math.floor(12 / this.visibleFieldsCount);
    },
  },
  watch: {
    breakDuration () {
      this.calculateDuration();
    },
    startTime () {
      this.calculateDuration();
    },
    endTime () {
      this.calculateDuration();
    },
    timesheetStartDate () {
      this.calculateDuration();
    },
    timesheetEndDate () {
      this.calculateDuration();
    },
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  async mounted () {
    await this.loadOnMount();
  },
  methods: {
    async loadOnMount () {
      this.loading = true;
      const orgExtId = await this.selectedOrganization.organization.external_id;
      await this.$store.dispatch('appusers/clearFilterAppUsersList');
      await this.fetchPayItems();
      await this.$store
        .dispatch('timesheets/fetchTimesheetDetails', {
          timesheetId: this.timesheetId,
        })
        .then(async () => {
          await this.$store.dispatch('projects/fetchOrganizationProjects', {
            organizationExtId: orgExtId,
          });
          await this.checkTimesheetPermissions();
          await this.fillData();
        });
      this.loading = false;
    },
    async fillData () {
      await this.getFilterAppUsersList(this.timesheetDetails.project.id);
      this.selectedProject = this.timesheetDetails.project.id;
      this.selectedUser = this.canEditAll
        ? this.timesheetDetails.app_user_organization.app_user_organization_id
        : null;
      const startDateOnly = moment(this.timesheetDetails.start_time)
        .local()
        .format('YYYY-MM-DD');
      this.timesheetStartDate = startDateOnly;
      const endDateOnly = moment(this.timesheetDetails.end_time)
        .local()
        .format('YYYY-MM-DD');
      this.timesheetEndDate = endDateOnly;
      this.breakDuration = this.timesheetDetails.break_time || '00:00';

      this.notes = this.timesheetDetails.notes;
      const workedHours = this.timesheetDetails.worked_hour.split(':')[0];
      const workedMins = this.timesheetDetails.worked_hour.split(':')[1];
      this.workerHours = workedHours;
      this.workerMins = workedMins;
      this.startTime = moment(this.timesheetDetails.start_time)
        .local()
        .format('HH:mm');
      this.endTime = moment(this.timesheetDetails.end_time)
        .local()
        .format('HH:mm');
      this.timeStart = this.startTime;
      this.timeEnd = this.endTime;
      this.type = this.timesheetDetails.pay_item.id;
      this.verifiedHours = this.timesheetDetails.verified_hours;
      this.paymentHours = this.timesheetDetails.payment_hours;
      this.actualWorkedHours = this.timesheetDetails.actual_work_hours;
    },
    checkTimesheetPermissions () {
      const role = this.selectedOrganization.app_user_role;
      const allPermissions = this.orgSettings.timesheet_permissions;
      let rolePer = null;

      if (allPermissions !== null) {
        switch (role) {
          case 'site-manager':
            rolePer = allPermissions.site_manager;
            break;
          case 'worker':
            rolePer = allPermissions.worker;
            break;
          case 'contractor':
            rolePer = allPermissions.contractor;
            break;
        }
      }
      this.canEditAll = rolePer.edit.all;
      // Show delete button
      this.deleteOwnPermission =
        this.selectedOrganization.app_user_organization_id ===
          this.timesheetDetails.app_user_organization
            .app_user_organization_id && rolePer.delete.own;
      this.deleteAllPermission = rolePer.delete.all;
      // Show edit button
      this.editOwnPermission =
        this.selectedOrganization.app_user_organization_id ===
          this.timesheetDetails.app_user_organization
            .app_user_organization_id && rolePer.edit.own;
      this.editAllPermission = rolePer.edit.all;
      return rolePer;
    },
    async getFilterAppUsersList (projectId) {
      if (this.canEditAll) {
        this.loading = true;
        await this.$store.dispatch('appusers/clearFilterAppUsersList');
        await this.$store.dispatch('appusers/fetchFilterAppUsersList', {
          orgExternalId: this.selectedOrganization.organization.external_id,
          params: {
            params: {
              requestStatus: ['accepted'],
              projectId: projectId,
              tracking: true,
              activeStatus: true,
            },
          },
        });
        this.loading = false;
      }
    },
    formatBreakDuration () {
      let value = (this.breakDuration || '').replace(/\D/g, '');

      if (value.length > 4) {
        value = value.slice(0, 4);
      }

      if (value.length >= 3) {
        this.breakDuration = `${value.slice(0, 2)}:${value.slice(2)}`;
      } else {
        this.breakDuration = value;
      }
    },
    async fetchPayItems () {
      await this.$store.dispatch('timesheets/fetchPayItems', {
        orgExtId: this.selectedOrganization.organization.external_id,
      });
    },
    async updateTimesheets () {
      if (!this.$refs.form.validate()) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Please fill the required fields before proceeding',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        return;
      }
      this.loading = true;
      const dateStartTime = moment(
        `${this.timesheetStartDate} ${this.startTime}`,
        'YYYY-MM-DD HH:mm',
      )
        .utc()
        .format('YYYY-MM-DDTHH:mm:ss[Z]');
      const dateEndTime = moment(
        `${this.timesheetEndDate} ${this.endTime}`,
        'YYYY-MM-DD HH:mm',
      )
        .utc()
        .format('YYYY-MM-DDTHH:mm:ss[Z]');
      await this.$store
        .dispatch('timesheets/updateTimesheet', {
          timesheetId: this.timesheetId,
          details: {
            project_id: this.selectedProject,
            app_user_organization_id: this.selectedUser,
            break_time: this.breakDuration || '00:00',
            notes: this.notes,
            pay_item_id: this.type,
            worked_hour: `${
              this.workerHours.length === 1
                ? '0' + this.workerHours
                : this.workerHours
            }:${
              this.workerMins.length === 1
                ? '0' + this.workerMins
                : this.workerMins
            }`,
            date: this.timesheetStartDate,
            start_time: dateStartTime,
            end_time: dateEndTime,
          },
        })
        .then((response) => {
          this.$emit('timesheet-updated');
          this.loading = false;
          this.showModal = false;
          this.$refs.form.reset();
          this.$store.dispatch(
            'alert/onAlert',
            {
              message: 'Timesheets updated successfully !',
              type: Constants.ALERT_TYPE_SUCCESS,
            },
            { root: true },
          );
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async confirmDelete () {
      this.loading = true;
      await this.$store
        .dispatch('timesheets/deleteTimesheet', {
          timesheetId: this.timesheetId,
        })
        .then(() => {
          this.$emit('timesheet-deleted');
          this.$store.dispatch(
            'alert/onAlert',
            {
              message: 'Timesheets deleted successfully !',
              type: Constants.ALERT_TYPE_SUCCESS,
            },
            { root: true },
          );
          this.showDeleteDialog = false;
          this.showModal = false;
          this.loading = false;
        })
        .catch(() => {
          this.showDeleteDialog = false;
          this.loading = false;
        });
    },
    calculateDuration () {
      if (
        this.timesheetStartDate &&
        this.startTime &&
        this.timesheetEndDate &&
        this.endTime
      ) {
        const start = moment(
          `${this.timesheetStartDate} ${this.startTime}`,
          'YYYY-MM-DD HH:mm',
        );
        const end = moment(
          `${this.timesheetEndDate} ${this.endTime}`,
          'YYYY-MM-DD HH:mm',
        );

        if (end.isSameOrAfter(start)) {
          let duration = moment.duration(end.diff(start));

          // Subtract break time only if break is enabled
          if (this.isBreakEnabled) {
            const [bh, bm] = (this.breakDuration || '00:00')
              .split(':')
              .map(Number);

            const breakMinutes = (bh || 0) * 60 + (bm || 0);
            duration = moment.duration(
              duration.asMinutes() - breakMinutes,
              'minutes',
            );
          }

          this.workerHours = String(Math.floor(duration.asHours())).padStart(
            2,
            '0',
          );
          this.workerMins = String(duration.minutes()).padStart(2, '0');
        } else {
          // fallback if somehow end < start
          this.workerHours = '00';
          this.workerMins = '00';
        }
      }
    },
    validateBreakDuration (value) {
      if (!value) return true;
      const regex = /^([0-9]{2}):([0-5][0-9])$/;
      return regex.test(value) || 'Break duration must be in HH:mm format';
    },
  },
};
</script>

<style scoped>
.theme--dark.v-list {
  background-color: white !important;
}

.v-input--selection-controls__input .v-icon {
  color: #ccc !important;
}

.theme--dark >>> .v-list-item {
  color: #37474f !important;
}

.theme--dark.v-label {
  color: rgba(255, 255, 255, 0.7);
}

.theme--dark.v-messages {
  color: #37474f !important;
}

.hint-text {
  font-size: 13px;
  color: #444444;
  margin-top: -13px !important;
}

.class-disabled .v-input--selection-controls__input .v-icon {
  color: #000 !important;
}

.grey-button {
  color: white;
}

.calculated-hours-panel {
  background: #dee9f4;
  border: 0.5px solid #c7d0d7;
}
</style>
